export default "__VITE_ASSET__ZaUiZyEs__"